import script from "./FreeReportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeReportForm.vue?vue&type=script&setup=true&lang=js"

import "./FreeReportForm.vue?vue&type=style&index=0&id=0f28adb1&lang=scss"

const __exports__ = script;

export default __exports__